define('components/loader/views/LoaderView', [
    'components/loader/templates/loaderview'
], function(tpl) {

    var LoaderView = Mazarine.View.extend({

        template: tpl,

        className: "maz-loader-view maz-valign-wrapper",

        initialize: function(options) {
            Mazarine.View.prototype.initialize.call(this);

            this.listenTo(this.model, 'change:percentage', _.bind(this.onPercentage, this));
        },

        onPercentage: function(model, _percentage) {
            this.$('.maz-percentage-value').html(Math.round(_percentage));

            var _css = {};

            _.each(model.get('propertiesUpdated'), function(property, index) {
                if (property === "opacity") {
                    _css[property] = Math.round(_percentage) / 100;
                } else {
                    _css[property] = Math.round(_percentage) + '%';
                }
            });

            this.$('.maz-background').css(_css);
        },

        remove: function() {
            this.$el.remove();
        }
    });

    return LoaderView;
});
